const icons = {
    shadow: require('images/icons/shadowAppIcon.png'),
    reflexion: require('images/icons/reflexion.png'),
    myfhe: require('images/icons/myfhe.png'),
    fhe: require('images/icons/fhe.png'),
    cocoon: require('images/icons/cocoon.png'),
    domalisa: require('images/icons/domalisa.png'),
    testbench: require('images/icons/testbench.png'),
    fhepool: require('images/icons/fhepool.png'),
    viebrock: require('images/icons/viebrock.png'),
    nogma: require('images/icons/nogma.png'),
    statistics: require('images/icons/statistics.png'),
    usersRights: require('images/icons/usersRights.png'),
    logging: require('images/icons/logging.png'),
    logout: require('images/icons/logout.png'),
    simulationenr: require('images/icons/simulationenr.png'),
    ticketsgit: require('images/icons/ticketsgit.png'),
    fheconnect: require('images/icons/fheconnect.png'),
    homing: require('images/icons/homing.png'),
    lacin: require('images/icons/lacin.png'),
    accesshabitat: require('images/icons/accesshabitat.png'),
    maestro: require('images/icons/maestro.png'),
    weezeo: require('images/icons/weezeo.png'),
    niceenergie: require('images/icons/niceenergie.png'),
    mghabitat: require('images/icons/mghabitat.png'),
    idealys: require('images/icons/idealys.png'),
    inogreen: require('images/icons/inogreen.png'),
};

export default icons;



// WEBPACK FOOTER //
// ./data/common/icons.js